import React, { useEffect } from "react";

/**
 * CredlyBadge renders a shareable Credly badge using their embed script.
 * Props:
 * - shareBadgeId: string (required)
 * - iframeWidth: number|string (default 150)
 * - iframeHeight: number|string (default 270)
 * - host: string (default https://www.credly.com)
 */
const CredlyBadge = ({
	shareBadgeId,
	iframeWidth = 150,
	iframeHeight = 270,
	host = "https://www.credly.com",
}) => {
	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://cdn.credly.com/assets/utilities/embed.js";
		script.async = true;
		document.body.appendChild(script);
		return () => {};
	}, [shareBadgeId]);

	return (
		<div style={{
			background: '#ffffff',
			border: '1px solid #e4e4e9',
			borderRadius: '16px',
			overflow: 'hidden',
			width: Number(iframeWidth),
			height: Number(iframeHeight),
			position: 'relative',
			boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
		}}>
			<div
				data-iframe-width={String(iframeWidth)}
				data-iframe-height={String(iframeHeight)}
				data-share-badge-id={shareBadgeId}
				data-share-badge-host={host}
				style={{ display: 'block' }}
			/>
			{/* overlay to tint the Credly footer bar in dark mode */}
			<div style={{
				position: 'absolute',
				bottom: 0,
				left: 0,
				right: 0,
				height: '36px',
				background: '#ffffff',
				pointerEvents: 'none',
			}} />
		</div>
	);
};

export default CredlyBadge;
